export const CRATE_TYPE_OPTIONS = [
  "Doos Zwart",
  "Doos Growers Glory",
  "Doos Green Bull",
  "Doos Lidl",
  "Zwart Klap 18604",
  "Groen Klap 186",
  "Ifco 6416",
  "Zwart klap Hoog 24604",
  "Groen klap Hoog 246",
  "Voorraadbak",
];

export const OWN_PALLET_TYPE = "Eigen pallet (geen voorraad)";

export const PALLET_TYPE_OPTIONS = [
  OWN_PALLET_TYPE,
  "Euro pallet",
  "Pool pallet",
  "LPR pallet",
  "Eenmalige pallet",
  "Euro Chep pallet",
  "CHEP Pool pallet",
  "Voorraadbak",
];

export const DEFAULT_PALLET_TYPE_BY_CRATE_TYPE = {
  "Doos Zwart": OWN_PALLET_TYPE,
  "Doos Growers Glory": OWN_PALLET_TYPE,
  "Doos Green Bull": "Eenmalige pallet",
  "Doos Lidl": "Eenmalige pallet",
  "Zwart Klap 18604": "LPR pallet",
  "Zwart klap Hoog 24604": "LPR pallet",
  "Groen Klap 186": "Pool pallet",
  "Groen klap Hoog 246": "Pool pallet",
  "Ifco 6416": "Euro pallet",
};

const FUST_TYPE_ALIASES = new Map([
  ["zwarte doos", "Doos Zwart"],
  ["doos zwart", "Doos Zwart"],
  ["growers glorie doos", "Doos Growers Glory"],
  ["doos growers glory", "Doos Growers Glory"],
  ["lidl doos", "Doos Lidl"],
  ["doos lidl", "Doos Lidl"],
  ["zwart klap 186", "Zwart Klap 18604"],
  ["zwart klap 18604", "Zwart Klap 18604"],
  ["groen klap 186", "Groen Klap 186"],
  ["hoog zwart klap 24604", "Zwart klap Hoog 24604"],
  ["zwart klap hoog 24604", "Zwart klap Hoog 24604"],
  ["hoog groen klap 246", "Groen klap Hoog 246"],
  ["groen klap hoog 246", "Groen klap Hoog 246"],
  ["chep euro pallet", "Euro Chep pallet"],
  ["euro chep pallet", "Euro Chep pallet"],
  ["etienne doos", "Doos Green Bull"],
  ["ifco 6416", "Ifco 6416"],
  ["doos green bull", "Doos Green Bull"],
  ["euro pallet", "Euro pallet"],
  ["pool pallet", "Pool pallet"],
  ["lpr pallet", "LPR pallet"],
  ["eenmalige pallet", "Eenmalige pallet"],
  ["chep pool pallet", "CHEP Pool pallet"],
  ["eigen pallet (geen voorraad)", OWN_PALLET_TYPE],
  ["voorraadbak", "Voorraadbak"],
]);

export const UNKNOWN_FUST_TYPE = "Niet ingevuld";
export const DEFAULT_CRATE_WARNING_MARGIN = 2500;

export function mergeFustTypeOptions(defaultTypes = [], catalogItems = []) {
  const seenNames = new Set();
  const safeDefaultTypes = Array.isArray(defaultTypes) ? defaultTypes : [];
  const safeCatalogItems = Array.isArray(catalogItems)
    ? catalogItems.filter((item) => typeof item === "string" || item?.active !== false)
    : [];

  return [...safeDefaultTypes, ...safeCatalogItems]
    .map((item) => typeof item === "string" ? item : item?.name)
    .map(normalizeFustType)
    .filter((name) => name !== UNKNOWN_FUST_TYPE)
    .filter((name) => {
      const normalizedName = name.toLocaleLowerCase("nl-NL");
      if (!name || seenNames.has(normalizedName)) return false;
      seenNames.add(normalizedName);
      return true;
    })
    .sort((left, right) => left.localeCompare(right, "nl", { sensitivity: "base" }));
}

export function isFustTypeHidden(type, hiddenTypes = []) {
  if (!String(type || "").trim()) return false;
  const normalizedType = normalizeFustType(type).toLocaleLowerCase("nl-NL");
  return hiddenTypes.some(
    (hiddenType) =>
      normalizeFustType(hiddenType).toLocaleLowerCase("nl-NL") === normalizedType
  );
}

const NEGATIVE_ONLY_WARNING_CRATE_TYPES = new Set([
  "Doos Green Bull",
  "Doos Lidl",
]);

const PALLET_WARNING_MARGIN_BY_TYPE = {
  "Euro pallet": 70,
  "Eenmalige pallet": 70,
  "LPR pallet": 30,
  "Pool pallet": 30,
  "Euro Chep pallet": 0,
  "CHEP Pool pallet": 0,
};

export function toNonNegativeInteger(value) {
  const quantity = Number(value);
  return Number.isFinite(quantity) && quantity > 0 ? Math.floor(quantity) : 0;
}

export function normalizeFustType(value) {
  const normalizedValue = String(value || "").trim();
  if (!normalizedValue) return UNKNOWN_FUST_TYPE;
  return FUST_TYPE_ALIASES.get(
    normalizedValue.toLocaleLowerCase("nl-NL")
  ) || normalizedValue;
}

export function getDefaultPalletType(crateType) {
  return DEFAULT_PALLET_TYPE_BY_CRATE_TYPE[normalizeFustType(crateType)] || "";
}

export function getPalletStockQuantity(palletType) {
  const normalizedType = normalizeFustType(palletType);
  return normalizedType === UNKNOWN_FUST_TYPE || normalizedType === OWN_PALLET_TYPE
    ? 0
    : 1;
}

function addQuantity(quantities, type, quantity) {
  const normalizedQuantity = Number(quantity);
  if (!Number.isFinite(normalizedQuantity) || normalizedQuantity === 0) return;

  const normalizedType = normalizeFustType(type);
  if (normalizedType === UNKNOWN_FUST_TYPE) return;
  quantities.set(normalizedType, (quantities.get(normalizedType) || 0) + normalizedQuantity);
}

export function aggregateFustMovements(movements = []) {
  const crateStock = new Map();
  const palletStock = new Map();

  movements.forEach((movement) => {
    const factor = movement?.direction === "out" ? -1 : 1;
    addQuantity(crateStock, movement?.crateType, factor * toNonNegativeInteger(movement?.crateQuantity));
    addQuantity(palletStock, movement?.palletType, factor * toNonNegativeInteger(movement?.palletQuantity));
  });

  return { crateStock, palletStock };
}

export function doesReadyPalletBelongToOrder(pallet, order) {
  if (!pallet || !order || pallet.status !== "ready") return false;

  const orderId = String(order.id || "");
  if (!orderId) return false;

  if (pallet.sourceType === "stock") {
    return String(pallet.assignedOrderId || "") === orderId;
  }

  if (String(pallet.orderId || "") === orderId) return true;

  const orderBatchId = String(order.palletBatchId || "").trim();
  return !!orderBatchId && String(pallet.palletBatchId || "").trim() === orderBatchId;
}

export function calculateOutstandingFustDemand(orders = [], readyPallets = []) {
  const crateDemand = new Map();
  const palletDemand = new Map();
  let remainingPalletsTotal = 0;
  let remainingCratesTotal = 0;

  orders.forEach((order) => {
    if (!order?.id || order.status === "done") return;

    const orderedPallets = toNonNegativeInteger(order.pallets);
    if (!orderedPallets) return;

    const readyPalletIds = new Set(
      readyPallets
        .filter((pallet) => doesReadyPalletBelongToOrder(pallet, order))
        .map((pallet) => String(pallet.palletId || pallet.id || ""))
        .filter(Boolean)
    );
    const remainingPallets = Math.max(0, orderedPallets - readyPalletIds.size);
    const remainingCrates = remainingPallets * toNonNegativeInteger(order.boxesPerPallet);

    const palletQuantity = getPalletStockQuantity(order.palletType);
    addQuantity(palletDemand, order.palletType, remainingPallets * palletQuantity);
    addQuantity(crateDemand, order.crateType, remainingCrates);
    remainingPalletsTotal += remainingPallets;
    remainingCratesTotal += remainingCrates;
  });

  return {
    crateDemand,
    palletDemand,
    remainingPalletsTotal,
    remainingCratesTotal,
  };
}

export function buildFustOverviewRows(stock, demand, defaultTypes = []) {
  const canonicalStock = new Map();
  const canonicalDemand = new Map();
  stock.forEach((quantity, type) => addQuantity(canonicalStock, type, quantity));
  demand.forEach((quantity, type) => addQuantity(canonicalDemand, type, quantity));
  const types = new Set([
    ...defaultTypes.map(normalizeFustType),
    ...canonicalStock.keys(),
    ...canonicalDemand.keys(),
  ]);

  return Array.from(types)
    .filter((type) => type !== UNKNOWN_FUST_TYPE)
    .map((type) => {
      const realtime = canonicalStock.get(type) || 0;
      const reserved = canonicalDemand.get(type) || 0;
      return {
        type,
        realtime,
        reserved,
        theoretical: realtime - reserved,
      };
    })
    .sort((left, right) =>
      left.type.localeCompare(right.type, "nl", { sensitivity: "base" })
    );
}

export function getLowCrateStockAlerts(rows = []) {
  return rows
    .filter((row) => {
      if (NEGATIVE_ONLY_WARNING_CRATE_TYPES.has(row.type)) {
        return row.theoretical < 0;
      }
      return row.theoretical < DEFAULT_CRATE_WARNING_MARGIN;
    })
    .map((row) => ({
      ...row,
      threshold: NEGATIVE_ONLY_WARNING_CRATE_TYPES.has(row.type)
        ? 0
        : DEFAULT_CRATE_WARNING_MARGIN,
    }));
}

export function getLowPalletStockAlerts(rows = []) {
  return rows
    .map((row) => ({
      ...row,
      threshold: PALLET_WARNING_MARGIN_BY_TYPE[row.type] ?? 0,
    }))
    .filter((row) => row.theoretical < row.threshold);
}
